export const preBuiltSectionRef = 'pre-built-section';
